import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const rolePermissionApi = createApi({
  reducerPath: "rolePermission",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
    prepareHeaders: (headers, { getState }) => {
      const { auth } = getState();
      const token = auth.user.token;
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", `application/json;charset=UTF-8`);
      return headers;
    },
  }),
  tagTypes: ["role", "permission"],
  endpoints: (builder) => ({
    roles: builder.query({
      query: (data) => {
        return {
          url: "/Auth/role",
          method: "GET",
          params: data,
        };
      },
      providesTags: ["role"],
    }),
    changeRoleStatus: builder.mutation({
      query: (data) => {
        return {
          url: "/Auth/updateRoleStatus",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["role"],
    }),
    permissions: builder.query({
      query: (data) => {
        return {
          url: "/Auth/getPermissionList",
          method: "GET",
          params: data,
        };
      },
      providesTags: ["permission"],
    }),
    rolePermissionsByID: builder.query({
      query: (data) => {
        return {
          url: "/Auth/RoleAndPermissionByID",
          method: "GET",
          params: {
            id: data,
          },
        };
      },
      providesTags: ["permission"],
    }),
    createRole: builder.mutation({
      query: (data) => {
        return {
          url: "/Auth/CreateNewRole",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["role"],
    }),
    updateRole: builder.mutation({
      query: (data) => {
        return {
          url: "/Auth/UpdateRole",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["role", "permission"],
    }),
    deleteRole: builder.mutation({
      query: (data) => {
        return {
          url: `/Auth/DeleteRole?keyID=${data}`,
          method: "POST",
        };
      },
      invalidatesTags: ["role", "permission"],
    }),
  }),
});

export const {
  useRolesQuery,
  useChangeRoleStatusMutation,
  usePermissionsQuery,
  useRolePermissionsByIDQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = rolePermissionApi;
